import { useTranslation } from 'react-i18next';

import { Button } from '@treams/treams-ui';

import ProductLayout from './ProductLayout';
import { useMixpanelTrack } from 'packages/kakapo-ui-application/hooks/useMixpanel';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';

export default function WorkspaceNotFound(props: { employee?: boolean; modal?: boolean }) {
	const { t } = useTranslation();
	const workspace = useWorkspace();

	useMixpanelTrack('/workspace-not-found');

	return (
		<ProductLayout
			modal={props.modal}
			title={t('workspace.notFound.title')}
			cta={
				<Button
					type="primary"
					title="Neem contact op"
					onClick={() => {
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						(window as any).$crisp.push(['do', 'chat:open']);
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						(window as any).$crisp.push([
							'set',
							'message:text',
							[
								t('workspace.notFound.chat.placeholder', {
									workspaceID: workspace.id,
								}),
							],
						]);
					}}
				/>
			}
		>
			<p>{t('workspace.notFound.subtitle')}</p>
			<p>{t('workspace.notFound.instruction')}</p>
		</ProductLayout>
	);
}
